import type { SYSAction } from "../../../../_ovlclient/src"
import type {
  HookFieldGetValueRender_ReturnType,
  HookFieldGetValueRender_Type,
  HookTableInit_Type,
} from "../../../../_ovlclient/src/global/hooks"

const HookField_U_Timestamp_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  let timestamp = value.row["U_Timestamp"]
  let dt = new Date(timestamp)
  let tval = dt.toLocaleTimeString()
  return {
    res: tval,
    valueRaw: tval,
  }
}

const HookTableInit: SYSAction<HookTableInit_Type> = (value, { global }) => {
  if (value.context !== "before") {
    return
  }
  if (value.tableDef.id === "SYSAudit") {
    let state = global.getState()
    if (state.ovl.app.backendType === "SAP") {
      value.tableDef.database.dataIdField = "Code"
      value.tableDef.database.dbInsertMode = "UDTAutoGUIDBoth"
    }
  }
}

export let hooks = { HookField_U_Timestamp_GetValueRender, HookTableInit }
